// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-product-grid .pagination-loader[data-v-2f7fc43b]{align-items:center;display:flex}.pagination-product-grid .pagination-loader .is-small[data-v-2f7fc43b]{height:1.375rem;width:1.375rem}.pagination-product-grid .ais-Pagination-link[data-v-2f7fc43b]{align-items:center;display:block;display:flex;height:3rem;justify-content:center;padding:0;width:3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
